import { ApiCustomField, ApiFieldTypes } from "@/types/custom-field.types.ts";

const compensationRollupFieldTypes: ApiFieldTypes[] = [
  ApiFieldTypes.employee_compensation_gross_total,
  ApiFieldTypes.employee_compensation_net_total,
  ApiFieldTypes.employee_compensation_total_cost,
];

export function isCompensationRollupField(type: ApiFieldTypes) {
  return compensationRollupFieldTypes.includes(type);
}

export function getCompensationRollupCellValue(fieldId: number, customFields: ApiCustomField[]) {
  const fieldValue = customFields.find(({ field }) => field.id === fieldId)?.value;
  const currencyValue = customFields.find(
    ({ field }) => field.type === ApiFieldTypes.employee_compensation_currency
  )?.value;

  return {
    amount: fieldValue?.value_float ?? fieldValue?.value_int ?? null,
    currency: currencyValue?.value_text_array?.[0] ?? currencyValue?.value_text ?? null,
  };
}
